import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesSchemesAssociateRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-schemes-associate',
	path: '/secure/admin/AssociateIssueTypeSchemes!default.jspa',
};
